<script setup lang="ts">
import { computed } from 'vue'
import type { DailyPanelProps } from '@/ui/daily-panel'
import { rateLabel } from '@/i18n/display-settings'
import ExpLiveReadout from '../ExpLiveReadout.vue'
import ExpReadoutStatus from '../ExpReadoutStatus.vue'
import ExpRateTrend from '../ExpRateTrend.vue'
const props = defineProps<Pick<DailyPanelProps, 'data' | 'locale'>>()
const experienceLabel = computed(() => rateLabel(props.locale, props.data.rateUnit))
const unit = computed(() => props.data.rateUnit === 'minute' ? '/min' : '/h')
const displayedAverage = computed(() => props.data.expDisplayRateValue === undefined
  ? props.data.expRateValue : props.data.expDisplayRateValue)
</script>
<template>
  <div class="daily-readouts">
    <div class="daily-average">
      <span class="daily-label"><span>{{ experienceLabel }}</span><ExpReadoutStatus icon-only :model="data.expReadout" :locale="locale" :context="data.sessionId ?? ''" /></span>
      <span class="daily-value"><strong data-exp-rate data-panel-measure :title="data.expReadout?.description">{{ data.expRate }}</strong><small data-panel-measure>{{ unit }}</small><span class="daily-trend" data-panel-measure><ExpRateTrend :model="data.expRateTrend" :context="`${data.sessionId}:${locale}:${data.rateUnit}`" :running="data.status === 'running'" /></span></span>
    </div>
    <ExpLiveReadout :model="data.expChart" :locale="locale" :rate-unit="data.rateUnit" :average="displayedAverage" />
  </div>
</template>
